import { useEffect } from 'react';

export default function useKey(
  eventName: 'keyup' | 'keydown' | 'keypress',
  key: string,
  handler: (e: KeyboardEvent) => void,
  dependencies: unknown[],
) {
  useEffect(() => {
    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.key === key) {
        handler(e);
      }
    };

    window.addEventListener(eventName, handleKeyUp);

    return () => {
      window.removeEventListener(eventName, handleKeyUp);
    };
  }, [handler, ...dependencies]);
}
